import { render, staticRenderFns } from "./PeriodicoOficial.vue?vue&type=template&id=6fbae736&scoped=true"
import script from "./PeriodicoOficial.vue?vue&type=script&lang=js"
export * from "./PeriodicoOficial.vue?vue&type=script&lang=js"
import style0 from "./PeriodicoOficial.vue?vue&type=style&index=0&id=6fbae736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbae736",
  null
  
)

export default component.exports